import React from 'react'
import classes from './home.module.css'
import { CopyrightOutlined } from '@ant-design/icons';
function Foot() {
    return (
        <div className={classes.footMain}>
            <div><CopyrightOutlined /> 2002 - 现在 bnsrj.com copyRight</div>
            <div style={{marginTop:'30px'}}>
            版权所有：湖北伯纳思网络科技有限公司
            </div>
            <div style={{marginTop:'30px'}}>
                <a target="_blank" onClick={() => {window.open('https://beian.miit.gov.cn/')}} style={{cursor:'pointer'}}>鄂ICP备18025660号-3</a>
            </div>            
        </div>
    )
}

export default Foot